import type { FaireProductEntity } from "../../entity_types/product";

export const p_gxbr5te2gx: FaireProductEntity = {
  token: "p_gxbr5te2gx",
  type: "product",
  name: "Craft Glass Soda | Bundaberg Guava Soda 24 Count",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/f32e524a8eb97324aec869c2194a6d8b51c6e09d196afdbbca744c006ce9a549.jpeg",
  galleryImageUrls: [],
  priceDollars: 103.09,
  description:
    "Bring a taste of the tropics to your beverage lineup with Craft Glass Soda Bundaberg Guava Soda 24 Count from Mr YuYu’s Wholesale. Crafted using traditional methods and natural guava flavoring, this Australian specialty soda delivers a vibrant, exotic taste without artificial additives.\n\nBottled in premium glass, Bundaberg Guava Soda preserves carbonation and flavor integrity while providing a high-quality, visually appealing drinking experience. Its bold, fruity profile appeals to consumers seeking adventurous flavors and authentic craft beverages.\n\nIdeal for wholesale buyers, specialty retailers, cafés, events, and resale environments, this 24-count case is a high-demand product that enhances any premium beverage inventory. Stocking Bundaberg Guava Soda ensures customers enjoy distinctive craft flavors and a memorable drinking experience.\n\nWith Mr YuYu’s Wholesale, businesses can offer authentic craft beverages that combine quality ingredients, traditional brewing methods, and exceptional taste.\n",
  tags: [],
  msrpDollars: 206.19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:11.794Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
